import { createFileRoute } from '@tanstack/react-router';

import { Insights } from '@/features/agents';

export const Route = createFileRoute('/_auth/agents/$agentId/analytics')({
  component: Insights,
});
